
export const hasToForceUserToSignForms = (mandatoryAppointments, profile) => {
    return (mandatoryAppointments?.length > 0 && profile?.brokerSegment?.toUpperCase?.() === `GBD`); 
};

export const convertQStringToDict = (qString, config = {}) => {
  const result = {};
  if (typeof qString !== 'string' || !qString?.length) return result;

  const { isDecodeValue = false, separator = '&', equalSign = '=' } = config;
  const qStringArray = qString.split(separator);
  qStringArray.forEach(item => {
    const [key, value] = item.split(equalSign);
    result[key] = isDecodeValue ? decodeURIComponent(value) : value;
  });
  return result;
};

export const convertStringIntoUrl = (url) => {
  const checkUrlString = url.includes("https://") || url.includes("http://");
  const updatedUrl = checkUrlString ? url: `https://${url}`;
  return updatedUrl;
}

export const checkSeniorLob = (lineOfBusiness) => {
  const isSeniorLob = Object.keys(lineOfBusiness)?.some(state =>
      lineOfBusiness[state]?.some(lob => lob?.toLowerCase() === 'senior')
    );
  return isSeniorLob;
}